import { render, staticRenderFns } from "./ScanStateTag.vue?vue&type=template&id=1c8ad60c&"
import script from "./ScanStateTag.vue?vue&type=script&lang=js&"
export * from "./ScanStateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports